import { useRef } from "react"
import MovieCard from "./MovieCard"

export default function CategoryRow({ label, movies, onMovieClick, currentMovie }) {
  const rowRef = useRef(null)

  const scroll = (dir) => {
    rowRef.current?.scrollBy({ left: dir * 400, behavior: "smooth" })
  }

  if (!movies || movies.length === 0) return null

  return (
    <section className="mt-8">
      <h2 className="text-lg font-semibold text-white mb-3 px-6 tracking-wide">{label}</h2>
      <div className="relative group/row">
        {/* Left button */}
        <button
          onClick={() => scroll(-1)}
          className="absolute left-0 top-0 bottom-0 z-10 w-10 bg-gradient-to-r from-zinc-950 to-transparent
            opacity-0 group-hover/row:opacity-100 transition-opacity flex items-center justify-center"
        >
          <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
        </button>

        {/* Scrollable row */}
        <div
          ref={rowRef}
          className="flex gap-3 overflow-x-auto scroll-smooth px-6 pb-2"
          style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}
        >
          {movies.map((movie) => (
            <MovieCard
              key={movie.id}
              movie={movie}
              onClick={onMovieClick}
              isActive={currentMovie?.id === movie.id}
            />
          ))}
        </div>

        {/* Right button */}
        <button
          onClick={() => scroll(1)}
          className="absolute right-0 top-0 bottom-0 z-10 w-10 bg-gradient-to-l from-zinc-950 to-transparent
            opacity-0 group-hover/row:opacity-100 transition-opacity flex items-center justify-center"
        >
          <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          </svg>
        </button>
      </div>
    </section>
  )
}
